import styled from 'styled-components';
import heroImg from '../../assets/images/hero.png';
import { COLORS, BREAKPOINTS, SPACING } from '../../style';

export const HeroContainer = styled.div`
  padding: ${SPACING.sm};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 140px;
  height: 100vh;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding-top: 80px;
  }

  button {
    margin-top: ${SPACING.xs};
  }
`;

export const HeroImage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url(${heroImg}) center top / cover no-repeat;
  border-radius: 30px;
  width: 100%;
  height: 90%;
  text-decoration: none;
  overflow: hidden;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    height: 80%;
    padding: ${SPACING.md};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    height: 70%;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 30px;
    transition: opacity 0.4s ease;
  }

  &::before {
    background: linear-gradient(rgba(0, 0, 0, 0.7), ${COLORS.blue});
    z-index: 1;
  }

  &::after {
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    z-index: 3;
  }
`;

export const SubTitle = styled.h2`
  color: ${COLORS.green};
  text-align: center;
  text-transform: uppercase;
  font-size: 40px;
  margin-bottom: ${SPACING.lg};
  z-index: 2;
  position: relative;
  min-height: 2.5em;

  .Typewriter__wrapper,
  .Typewriter__cursor {
    display: inline-block;
    color: ${COLORS.green};
    font-weight: 700;
  }

  @media (max-width: ${BREAKPOINTS.notebook}) {
    font-size: 32px;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    font-size: 24px;
    margin-bottom: ${SPACING.md};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    font-size: 18px;
  }
`;

export const SubInter = styled.h3`
  color: ${COLORS.white};
  text-align: center;
  font-weight: 300;
  font-size: 32px;
  z-index: 2;
  position: relative;

  @media (max-width: ${BREAKPOINTS.notebook}) {
    font-size: 24px;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    font-size: 20px;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    font-size: 18px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: ${SPACING.sm};
  gap: ${SPACING.xs};

  @media (max-width: ${BREAKPOINTS.tablet}) {
    flex-direction: column;
  }
`;
